// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__tc1Ro","textNotFound":"NotFound_textNotFound__7AYEo","footer":"NotFound_footer__8+zG8","notFoundContainer":"NotFound_notFoundContainer__lmx1j"};